function loadDeferredScript() {
  let fired = false;

  async function kickTrigger() {
    if (fired) return;
    fired = true;

    enableDeferredScripts();
  }

  document.addEventListener("focus", kickTrigger, { once: true, passive: true });
  document.addEventListener("mousemove", kickTrigger, { once: true, passive: true });
  document.addEventListener("wheel", kickTrigger, { once: true, passive: true });
  document.addEventListener("touchstart", kickTrigger, { once: true, passive: true });
  document.addEventListener("keydown", kickTrigger, { once: true, passive: true });
  document.addEventListener("scroll", kickTrigger, { once: true, passive: true });

  async function enableDeferredScripts() {
    document.querySelectorAll("[data-deferred-script]").forEach((script) => {
      const src = script.getAttribute("data-src");
      script.removeAttribute("data-src");
      script.removeAttribute("data-deferred-script");
      script.setAttribute("src", src);
    });
  }
}

loadDeferredScript();
